import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'components/dialog/Modals'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { fail, success } from 'features/toast/Toast'
import { isEmptyObject, mbToByte } from 'utils'
import Button from 'components/form/Button'
import classNames from 'classnames'
import FileInput from 'components/form/FileInput'
import {
  clearFile,
  createKeywordPlanner,
  fetchKeywordTemplateFile,
  hideKeywordUploadModal,
  uploadKeywordPlannerFile,
} from 'features/bulk/keywordPlanner/keywordUploadModalSlice'
import { fetchKeywordPlannerList } from 'features/bulk/keywordPlanner/keywordUploadSlice'

const FILE_SIZE_LIMIT = mbToByte(10)

const KeywordUploadModal = () => {
  const dispatch = useDispatch()
  const {
    isShow,
    templateFileUrl,
    templateLoading,
    uploading,
    disabled,
    file,
  } = useSelector(state => state.bulk.keywordUploadModal)

  useEffect(() => {
    if (isShow) {
      dispatch(fetchKeywordTemplateFile())
    }
  }, [dispatch, isShow])

  const handleClose = () => {
    if (uploading) {
      fail('업로드 중인 파일이 있습니다.')
    } else {
      dispatch(hideKeywordUploadModal())
    }
  }

  const handleConfirm = async () => {
    const { payload } = await dispatch(createKeywordPlanner())
    if (isEmptyObject(payload)) {
      success('요청 내용이 등록되었습니다.')
    } else {
      Object.keys(payload).forEach(key => {
        const { message, fileNames } = payload[key]
        fail(`${message}\n${fileNames.join(', ')}`)
      })
    }
    dispatch(hideKeywordUploadModal())
    dispatch(fetchKeywordPlannerList())
  }

  const handleFileChange = async inputFiles => {
    const [inputFile] = inputFiles
    if (inputFile.size > FILE_SIZE_LIMIT) {
      fail(
        '파일 요청 용량이 초과하였습니다.\n파일은 5만행 / 10MB 미만 파일로 요청 바랍니다.'
      )
    } else if (inputFile.name.length > 50 + 4) {
      fail('파일명은 50자까지 등록할 수 있습니다.')
    } else {
      await dispatch(uploadKeywordPlannerFile(inputFile))
    }
  }

  const handleTemplateDownload = () => {
    if (templateFileUrl) {
      window.open(templateFileUrl)
    }
  }

  return (
    <Modal className="manage_layer" on={isShow}>
      <ConfirmModal
        title="업로드 등록하기"
        handleClose={handleClose}
        onConfirm={handleConfirm}
        confirmDisabled={disabled || file === null}>
        <div className="item_manage">
          <Button
            size="small"
            onClick={handleTemplateDownload}
            disabled={templateLoading || templateFileUrl === null}>
            템플릿 다운로드
          </Button>
          <p className="desc_info">
            파일은 최대 5만 행 / 10mb의 용량 제한이 있습니다.
          </p>
        </div>
        <div className="item_manage">
          <strong className="tit_manage">파일 첨부</strong>
          <div className="box_fileupload">
            {file ? (
              <div className="item_fileupload">
                <ul className="list_file">
                  <li>
                    {file.name}
                    <button
                      type="button"
                      className="btn_del"
                      onClick={() => {
                        dispatch(clearFile())
                      }}>
                      <span className="ico_comm">삭제</span>
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <>
                <div
                  className={classNames('btn_gm gm_bl', {
                    in_active: uploading,
                  })}
                  style={{ position: 'relative' }}>
                  <label htmlFor="inpFile" className="lab_file">
                    <span className="inner_g">파일업로드</span>
                  </label>
                  <FileInput
                    id="inpFile"
                    className="inp_file"
                    hidden={false}
                    clearFiles
                    multiple={false}
                    accept=".csv"
                    onFileChange={handleFileChange}
                    disabled={uploading}
                  />
                </div>
                <p className="txt_fileupload">파일을 등록해주세요.</p>
              </>
            )}
          </div>
        </div>
      </ConfirmModal>
    </Modal>
  )
}
export default KeywordUploadModal
